import React, { Fragment } from 'react'
import { BulkDeleteButton } from 'react-admin'

export const ConfirmBulkDelete = props => (
  <Fragment>
    <BulkDeleteButton {...props} undoable={false} />
  </Fragment>
)
